import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";


const firebaseConfig = {
    apiKey: "AIzaSyCN1FmEJW98qqOqGugDnzR-fTfj79XaK28",
    authDomain: "mridapub.in",
    projectId: "book-48ca9",
    storageBucket: "book-48ca9.firebasestorage.app",
    messagingSenderId: "795714356208",
    appId: "1:795714356208:web:e2a7a2e5198ed12a49d335",
    measurementId: "G-NWNNNW4VDL"
};


const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);
export const auth = getAuth(app);
export { firebaseConfig };
